export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/ReInspect.65fc305f.svg","height":96,"width":122,"blurWidth":0,"blurHeight":0};